module.exports = __webpack_public_path__ + "images/hauts-du-port-5041635f0ee645a10658823acf4c338a.jpg";